module.exports = "https://coursera_assets.s3.amazonaws.com/images/00adc2505be3c9d31ac17f6ed0d847ac.png";